import React from 'react';
import { Link } from 'react-router-dom';
import './MyCleanStudioFooter.css';

function MyCleanStudioFooter() {
  return (
    <footer className="mycleanstudio-footer">
      <div className="mycleanstudio-footer-content">
        <p className="mycleanstudio-footer-copyright">
          © {new Date().getFullYear()} myCleanStudio. All rights reserved.
        </p>
        <div className="mycleanstudio-footer-links">
          <Link to="/privacy" className="mycleanstudio-footer-link">Privacy Policy</Link>
          <Link to="/terms" className="mycleanstudio-footer-link">Terms of Service</Link>
          <a href="mailto:support@mycleanstudio.com" className="mycleanstudio-footer-link">Contact Us</a>
        </div>
      </div>
    </footer>
  );
}

export default MyCleanStudioFooter;

